import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/brand";

export default function WhatsAppFloat() {
  return (
    <a
      href={waLink("Hi Digi Savvy! I'd like to chat about real-estate marketing.")}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-30 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg shadow-emerald-500/40 hover:scale-110 transition pulse-ring"
    >
      <MessageCircle className="w-6 h-6 text-white" fill="white" />
    </a>
  );
}
